<template>
  <Form :ref="refName" :model="formModel" :rules="formRules" inline>
    <FormItem :label="_vm.$t('用户名称')" class="layout100" prop="name">
      <Input v-model="formModel.name" :placeholder="_vm.$t('请输入用户名称')"></Input>
    </FormItem>

    <FormItem :label="_vm.$t('手机号/邮箱')" class="layout100" prop="admin_name">
      <Input v-model="formModel.admin_name" :placeholder="_vm.$t('请输入手机号/邮箱')"></Input>
    </FormItem>

    <FormItem :label="_vm.$t('密码')" class="layout100" prop="password">
      <Input v-model="formModel.password" :placeholder="_vm.$t('请输入密码')"></Input>
    </FormItem>

    <FormItem :label="_vm.$t('角色')" class="layout100" prop="group_codes">
      <Select v-model="formModel.group_codes" placeholder="请选择角色">
        <Option v-for="(item, i) in states" :key="'状态' + i" :value="item.group_code">{{ item.group_name }}</Option>
      </Select>
    </FormItem>
  </Form>
</template>

<script>
import { renderFormMixins } from '@/mixins/renderFormMixins';
import { grouplist } from "@/api/auth";

export default {
  name: "addRole",
  mixins: [renderFormMixins],
  data() {
    return {
      states: [],
      formModel: {
        name: null,
        admin_name: null,
        password: null,
        group_codes: null,
      },
      formRules: this.calculateFormRules() // 初始化时调用
    };
  },
  props: {
    _vm: {},
    edit: {},
    setData: {},
    type: '' // 角色类型，可能是 'add' 或其他
  },
  methods: {
    // 根据 type 计算表单规则
    calculateFormRules() {
      return {
        name: [
          { required: true, message: this._vm.$t('请输入角色名称'), trigger: 'blur' }
        ],
        admin_name: [
          {
            required: true,
            message: this._vm.$t('请输入手机号/邮箱'),
            trigger: 'blur'
          },
          {
            validator: this.validateAdminName,
            trigger: 'blur'
          }
        ],
        group_codes: [
          { required: true, message: '请选择角色', trigger: 'change' }
        ],
        password: [
          { required: this.type === 'add', message: this._vm.$t('请输入密码'), trigger: 'blur' }
        ]
      };
    },
    validateAdminName(rule, value, callback) {
      const phoneRegex = /^[1][3-9][0-9]{9}$/; // 手机格式
      const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/; // 邮箱格式

      // 判断格式是否正确
      if (!value) {
        callback(new Error(this._vm.$t('手机号或邮箱不能为空')));
      } else if (!phoneRegex.test(value) && !emailRegex.test(value)) {
        callback(new Error(this._vm.$t('请输入有效的手机号或邮箱')));
      } else {
        callback(); // 验证通过
      }
    },
  },
  mounted() {
    grouplist({ page: 1, page_size: 999 }).then((res) => {
      this.states = res.body.list;
    });
  },
  created() {
    if (this.edit) {
      Object.assign(this.formModel, this.setData);
    }
    this.formRules = this.calculateFormRules(); // 重新计算规则
  }
};
</script>

<style scoped>
.layout50,
.layout100 {
  margin-bottom: 15px;
}

.layout50 {
  width: calc(50% - 12px);
}

.layout100 {
  width: calc(100% - 12px);
}

.formHeight {
  height: 400px;
  overflow-y: auto;
}
</style>
